/**
 * Date utility functions for TodoItem
 */

import { formatDueDateDisplay, parseMissionDate } from '../../../../../../utils/missionDates';

const MS_DAY = 1000 * 60 * 60 * 24;

// Format due date for display (aligned with card/table due formatting)
export const formatDueDate = (dateStr) => {
  const formatted = formatDueDateDisplay(dateStr);
  return formatted ? formatted.text : null;
};

// Get due date urgency class
export const getDueDateClass = (dateStr) => {
  if (!dateStr) return '';
  const due = parseMissionDate(dateStr);
  if (!due) return '';
  const now = new Date();
  if (due.getTime() < now.getTime()) return 'todo-item__due--overdue';
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dueDayStart = new Date(due.getFullYear(), due.getMonth(), due.getDate());
  const dayDiff = Math.round((dueDayStart - todayStart) / MS_DAY);
  if (dayDiff === 0) return 'todo-item__due--today';
  if (dayDiff === 1 || dayDiff === 2) return 'todo-item__due--soon';
  return '';
};

// Format relative date for display (for created, started, completed, updated dates)
export const formatRelativeDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;
  return `${Math.floor(diffDays / 365)}y ago`;
};
